var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, makeObservable } from 'mobx';
import { Reaction } from '../../../utils/mobx/Reaction';
import { head } from '../../../utils/helper/lodash_replacements';
export class MediaAborter {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
        this.abort = new Reaction({
            when: () => !!this.nextPlaybackToAbort,
            action: this.abortNextPlayback,
            name: 'abortNextPlayback',
            onlyIfTrue: true,
            setupWhenIdle: true,
        });
    }
    abort;
    get app() {
        return this.parent.parent;
    }
    get playbacksToAbort() {
        return this.app.mediaPlayer.intents.filter(intent => intent.intentAbort.shouldAbort);
    }
    get nextPlaybackToAbort() {
        return head(this.playbacksToAbort);
    }
    abortNextPlayback() {
        if (!this.nextPlaybackToAbort)
            return;
        this.nextPlaybackToAbort.intentActions.abort();
    }
}
__decorate([
    computed
], MediaAborter.prototype, "playbacksToAbort", null);
__decorate([
    computed
], MediaAborter.prototype, "nextPlaybackToAbort", null);
__decorate([
    action.bound
], MediaAborter.prototype, "abortNextPlayback", null);
